import { saveAs } from "file-saver";

const CSV_HEADERS = [
  "Type",
  "Student ID",
  "Name",
  "Arrival",
  "Departure",
  "Total",
  "Paid",
  "Outstanding",
  "Agent",
  "Agent Phone",
  "Agent Email",
];

function num(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : "";
}

export function downloadOutstandingBalancesCsv(rows, selectedYear) {
  const body = (rows || []).map((r) => {
    const isGroup = r.rowType === "GROUP";
    return [
      isGroup ? "Group" : "Student",
      isGroup ? "" : r.studentId,
      isGroup ? r.bookingGroupName : r.studentName,
      r.arrival,
      r.departure,
      num(r.totalBookingValue),
      num(r.totalPayments),
      num(r.outstandingBalance),
      r.agentName,
      r.agentPhone,
      r.agentEmail,
    ];
  });

  const csvContent = [CSV_HEADERS, ...body]
    .map((row) =>
      row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
  saveAs(blob, `outstanding_balances_${selectedYear}.csv`);
}
